<template>
  <div>
    <div :key="$store.getters['resource/currentResource'].key">
      <event-view
        :id="routeId"
        :editing="true"
      >
      </event-view>
    </div>
  </div>
</template>

<script>
  import EventView from "./TiEventView.vue";

  export default {
    components: {
      EventView
    },
    middleware: 'auth',
    name: 'TiEventEditing',
    computed: {
      routeId () {
        return this.$route.params.id
      }
    },
    created() {
      if (!this.$route.params.id) {
        this.$router.push({path: '/tievents'})
      }
    }
  }
</script>
